import client from './client';

const salesActionUrl = '/api/v1/salesAction';

export const getProjectList = (usrUuid, searchParams) => {
  return client.get(`${salesActionUrl}/projectList`, {
    params: { 
      usrUuid, 
      ...searchParams
    }
  });
};

export const getActionList = (usrUuid, searchDate) => {
  return client.get(`${salesActionUrl}/list`, {
    params: { usrUuid, searchDate }
  });
};

export const getActionDetail = (activityId) => {
  return client.get(`${salesActionUrl}/${activityId}`);
};

export const saveSalesAction = (finalData) => {
  return client.post(`${salesActionUrl}/save`, finalData);
};

export const deleteSalesAction = (params) => {
  return client.post(`${salesActionUrl}/delete`, params);
};

// 🏢 👤 [추가] 로그인한 유저 UUID를 던져 부서 리스트와 유저 리스트를 동시에 리턴받는 단일 복합 API
export const getDepartmentAndUserList = (usrUuid) => {
  return client.get(`${salesActionUrl}/departmentAndUserList`, {
    params: { usrUuid }
  });
};

export const getActionStat = (dptUuid, usrUuid, startDate, endDate, loginUuid) => 
    client.get(`${salesActionUrl}/stats`, {
        params: { dptUuid, usrUuid, startDate, endDate, loginUuid } // ◀ loginUuid 추가
    });

export const getActionStatList = (dptUuid, usrUuid, startDate, endDate, loginUuid) => 
    client.get(`${salesActionUrl}/statList`, {
        params: { dptUuid, usrUuid, startDate, endDate, loginUuid } // ◀ loginUuid 추가
    });